import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconFilter1: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconFilter1"><Path d="M20.5 3.5H3.5V7.5L9.5 14.5V21.5L14.5 19.5V14.5L20.5 7.5V3.5Z" stroke="currentColor"/></CentralIconBase>;
});

export default IconFilter1;
